var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_1805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2184 15.5056C13.1661 16.3303 12.4477 16.9997 11.6146 16.9997H3.38471C2.55167 16.9997 1.83348 16.3303 1.78092 15.5056L1.07143 4.24971H13.9286L13.2184 15.5056ZM0.535715 1.06221H4.28572L4.67344 0.293221C4.76414 0.11326 4.94967 -0.000427246 5.15257 -0.000427246H9.8471C10.05 -0.000427246 10.2355 0.11326 10.3262 0.293221L10.7143 1.06221H14.4643C14.7601 1.06221 15 1.30001 15 1.59346V2.65596C15 2.94934 14.7601 3.18721 14.4643 3.18721H0.535715C0.239799 3.18721 0 2.94934 0 2.65596V1.59346C0 1.29994 0.241072 1.06221 0.535715 1.06221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_1805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.f7251aaa4a96baf3557fd373ffc98138.svg";
export { ForwardRef as ReactComponent };